// Angular
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

export enum CurrencyType {
    symbol = 'symbol',
    code = 'code',
}

@Component({
    selector: 'price-real-amount',
    template: `
        <span class="price"
              [ngClass]="type"
              [innerHTML]="value | priceRealAmount: currency:currencyType"
              *ngIf="hasValue()"></span>
        <span *ngIf="value === null && emptyLabel" class="label" [ngClass]="type">{{ emptyLabel }}</span>
    `,
    styles: [`
        .price,
        .label {
            font-weight: 600;
        }

        .price.big, .label.big {
            font-size: 1.5rem;
        }

        .price.large, .label.large {
            font-size: 1.5rem;
            font-weight: normal;
        }

        .price.default, .label.default {
            font-size: 1rem;
        }

        .price.light, .label.light {
            font-size: 1rem;
            font-weight: normal;
        }

        .price.smallCurrency .symbol {
            font-size: 60%;
            color: rgba(65, 65, 65, .6);
        }
        .price.small {
            font-style: italic;
            font-size: .75rem;
            font-weight: normal;
        }
    `],
    encapsulation: ViewEncapsulation.ShadowDom
})

export class PriceRealAmountComponent {
    @Input()
    public value: number;

    @Input()
    public type: 'big' | 'default' | 'large' | 'light' | 'smallCurrency' = 'default';

    @Input()
    public emptyLabel: string;

    @Input()
    public currency: string = 'EUR';

    @Input()
    public showZero: boolean;

    @Input()
    public currencyType: CurrencyType = CurrencyType.symbol;

    public hasValue(): boolean {
        if (this.showZero) {
            return Boolean(this.value) || this.value === 0;
        }
        return Boolean(this.value);
    }

}